import isFunction from '../../helpers/is-function';
import loadScript from '../load-script/load-script';
import loadManifestJsonFile from './load-manifest-json-file';

export const isStringHttp = (string: string) =>
  /(http(s?)):\/\//gi.test(string);
export const isString = (string: string) => typeof string === 'string';

// TODO: implement other types besides .js
export default async ({ file, manifest, moduleName }) => {
  try {
    const isLocalImport = isFunction(file);
    //* if function, resolve it
    if (isLocalImport) return file();

    //* if file is string nad has http, load script
    if (isStringHttp(file)) return loadScript({ url: file, name: moduleName });

    //* if file is string, and has manifest, load script from manifest
    if (isString(file) && manifest) {
      let manifestFile;
      try {
        manifestFile = (await loadManifestJsonFile(manifest)) || {};
      } catch (error) {
        console.error(
          `there was an issue trying to load manifest file from ${manifest}`
        );
        return {};
      }

      const hashFileMap = manifestFile[file];
      if (!hashFileMap) return Promise.resolve();

      return loadScript({ url: hashFileMap, name: moduleName });
    }

    console.error('cant figure out what you want me to load', {
      file,
      manifest
    });

    return Promise.resolve();
  } catch (err) {
    console.error(
      `there was an error trying to load ${file} from ${moduleName} module`,
      {
        err
      }
    );

    throw err;
  }
};
